var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-tooltip',{attrs:{"bottom":"","open-delay":"400"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"disabled":_vm.disabled}},'v-btn',_vm.$attrs,false),Object.assign({}, on, _vm.activators)),[_c('v-icon',[_vm._v("mdi-"),_vm._t("default")],2)],1)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }